export default  {
  bindings: {
    page: '=',
    pageDetails: '<',
    type: '<'
  },
  controller: 'pageContentFormController',
  template: require('../views/pageContent.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.form.component.js